import React, { Fragment } from 'react';
import * as R from 'ramda';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import Lens from '@mui/icons-material/Lens';

var useStyles = makeStyles(function (theme) {
  return {
    title: {
      color: theme.palette.text.primary
    },
    subtitle: {
      color: theme.palette.text.secondary,
      lineHeight: 1.3
    },
    icon: {
      height: '0.35em',
      color: theme.palette.text.secondary
    }
  };
});

var TableHeader = function TableHeader(_ref) {
  var header = _ref.header;

  var classes = useStyles();
  return React.createElement(
    'div',
    { className: classes.container },
    React.createElement(
      Typography,
      { variant: 'h5', className: classes.title },
      R.prop('title')(header)
    ),
    React.createElement(
      Typography,
      { variant: 'subtitle1', className: classes.subtitle },
      R.pipe(R.propOr([], 'subtitle'), R.intersperse(React.createElement(Lens, { className: classes.icon })), R.addIndex(R.map)(function (v, index) {
        return React.createElement(
          Fragment,
          { key: R.toString([R.prop('title')(header), index]) },
          v
        );
      }))(header)
    ),
    React.createElement(
      Typography,
      { variant: 'subtitle1', className: classes.subtitle },
      R.prop('uprs')(header)
    )
  );
};

TableHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  header: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.array,
    uprs: PropTypes.string
  })
} : {};

export default TableHeader;